import { mpBackend } from '../../../../../config/axios';
import { transformHeaderData } from '../../../../../pages/services/[planSeoSlug]/api/transformer';
import {
  THeader,
  TSearchResultFull,
} from '../../../../../pages/services/[planSeoSlug]/api/types';

export const getHeaderDetails = (): Promise<THeader> => {
  return mpBackend.get(`header`).then((data) => {
    return transformHeaderData(data);
  });
};

export type TLogoutRes = {
  success: boolean;
  message: string;
};

export const logoutApi = (): Promise<TLogoutRes> => {
  return mpBackend
    .get(`user/logout`)
    .then((data) => {
      return data;
    })
    .catch(() => {
      console.log('logout api failing');
    });
};

export const searchApi = (query: string): Promise<TSearchResultFull> => {
  return mpBackend
    .get(`search?query=${query}`)
    .then((data) => {
      return data;
    })
    .catch(() => {
      console.log('search api failing');
    });
};
